module.exports = __webpack_public_path__ + "r6-4428e17a.webp";